// 最新のActual/Delay/Framerate等の現在値を表示するパネル。
export const BpsLogNowPanel = (props: {
  latestActualBps: number | null;
  latestDelayTime: number | null;
  latestFrameRate: number | null;
}) => {
  const { latestActualBps, latestDelayTime, latestFrameRate } = props;

  return (
    <div className="bpslogNowPanel" aria-label="現在値">
      <div className="bpslogNowItem">
        <div className="bpslogNowLabel">Actual Bitrate</div>
        <div className="bpslogNowValue">
          {latestActualBps !== null ? (
            <>
              {latestActualBps.toFixed(2)} <span>Mbps</span>
            </>
          ) : (
            <>
              -- <span>Mbps</span>
            </>
          )}
        </div>
      </div>

      <div className="bpslogNowItem">
        <div className="bpslogNowLabel">Delay</div>
        <div className="bpslogNowValue">
          {latestDelayTime !== null ? (
            <>
              {latestDelayTime} <span>ms</span>
            </>
          ) : (
            <>
              -- <span>ms</span>
            </>
          )}
        </div>
      </div>

      <div className="bpslogNowItem">
        <div className="bpslogNowLabel">Framerate</div>
        <div className="bpslogNowValue">
          {latestFrameRate !== null ? (
            <>
              {latestFrameRate} <span>fps</span>
            </>
          ) : (
            <>
              -- <span>fps</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
